import { useEffect } from 'react';
import { useAppDispatch } from 'store/hooks';
import settingServiceSelectors from '../selectors';
import settingServiceActions from '../actions';

const useGetReceiptPrintConfig = (lazy?: boolean) => {
  const dispatch = useAppDispatch();
  const data = settingServiceSelectors.getReceiptPrintConfig();

  const mutate = () => {
    dispatch(settingServiceActions.getReceiptPrintConfig.fetch());
  };

  useEffect(() => {
    if (!lazy) {
      mutate();
    }
  }, []);

  return { data, mutate } as const;
};

export default useGetReceiptPrintConfig;
